import Button from '@mui/material/Button';
import { grey, red } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';
import WarnIcon from '@mui/icons-material/Warning';
import Cookie from 'js-cookie';
import { nanoid } from 'nanoid';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { ROOTURL } from '../../config';
import { GET_HIVE_USERNAME } from '../../helpers/graphql/profile';
import graphQLClient from '../../helpers/graphQLClient';
import {
  hasHivePostingAuthority,
  requestPostingAuthority,
} from '../../helpers/hasPostingAuthority';
import { getUser } from '../../helpers/token';

const useStyles = makeStyles()(theme => ({
  container: {
    margin: '8px',
  },
  topPaddingContainer: {
    margin: '50px 8px 8px 8px',
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: 70,
  },
  iconSpan: {
    maxWidth: 100,
    flexGrow: 1,
    width: 100,
    backgroundColor: red[600],
    borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    height: 38,
    width: 38,
    // marginTop: 15,
    maxWidth: '100%',
    color: grey[50],
    minHeight: 70,
    padding: '5px',
  },
  content: {
    flexGrow: 1,
    padding: '5px 10px',
    backgroundColor: red[400],
    borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
  },
  title: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: 1.5,
    color: grey[50],
  },
  text: {
    fontSize: 15,
    fontWeight: 'medium',
    lineHeight: 1.7,
    color: grey[50],
    paddingBottom: '5px',
  },
}));

export default function HiveAuthorityCheck({ isTopPadding }) {
  const [hasPostingAuthority, setHasPostingAuthority] = useState(undefined);
  const [hiveUser, setHiveUser] = useState(undefined);

  const checkPostingAuthority = () => {
    const username = getUser();
    if (!username) return;

    graphQLClient(GET_HIVE_USERNAME, { username }).then(({ profile }) => {
      if (!profile || !profile.hive) return;
      setHiveUser(profile.hive);
      hasHivePostingAuthority(profile.hive).then(res => {
        if (res) Cookie.set('postingAuthorityCheckPassed', profile.hive);
        setHasPostingAuthority(res);
      });
    });
  };

  useEffect(() => {
    const username = getUser();
    const hasCookie = Cookie.get('postingAuthorityCheckPassed');
    if (hasCookie === username) return;
    checkPostingAuthority();
  }, []);

  const { enqueueSnackbar } = useSnackbar();

  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      enqueueSnackbar(notification.message, { variant });
    }
  };

  const requestAuthority = () => {
    // Use hivesigner if keychain not installed
    if (!window.hive_keychain) {
      let csrfState = Cookie.get('csrf_state');
      if (!csrfState) {
        csrfState = nanoid();
        Cookie.set('csrf_state', csrfState);
      }
      window.open(
        `https://hivesigner.com/login-request/travelfeed.app?redirect_uri=${ROOTURL}%2Flogin%2Fhive&scope=posting&state=${csrfState}`,
      );
    } else
      requestPostingAuthority(hiveUser).then(postAuthRes => {
        newNotification(postAuthRes);
        if (postAuthRes.success) setHasPostingAuthority(true);
      });
  };

  const { classes } = useStyles();

  if (hasPostingAuthority !== false) return <></>;
  return (
    <div
      className={isTopPadding ? classes.topPaddingContainer : classes.container}
    >
      <Paper className={classes.root}>
        <div className={classes.iconSpan}>
          <WarnIcon className={classes.icon} />
        </div>
        <div className={classes.content}>
          <div className={classes.title}>Missing Hive Posting Authority</div>
          <div className={classes.text}>
            Authorize TravelFeed to post to your Hive account if you want your
            posts, comments and votes to appear on Hive
          </div>
          <div>
            <Button
              onClick={requestAuthority}
              color="primary"
              variant="contained"
            >
              Grant posting authority
            </Button>
          </div>
        </div>
      </Paper>
    </div>
  );
}
